import { useContext } from 'react';
import { SnackbarContext } from '../contexts/SnackbarContext';

export default function useSnackbar() {
  const snackbarContext = useContext(SnackbarContext);

  if (!snackbarContext) {
    throw Error('useSnackbar must be used within a snackbarContextProvider.');
  }

  return snackbarContext;
}
